import { render, staticRenderFns } from "./lisaa-arvioitavan-kokonaisuuden-kategoria.vue?vue&type=template&id=08153807&scoped=true&"
import script from "./lisaa-arvioitavan-kokonaisuuden-kategoria.vue?vue&type=script&lang=ts&"
export * from "./lisaa-arvioitavan-kokonaisuuden-kategoria.vue?vue&type=script&lang=ts&"
import style0 from "./lisaa-arvioitavan-kokonaisuuden-kategoria.vue?vue&type=style&index=0&id=08153807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08153807",
  null
  
)

export default component.exports